import React from 'react';
import { FiUser, FiFileText } from 'react-icons/fi';
import { useGuest } from '../../context/GuestContext';

const CERTIFICATIONS = [
  'SOC 2 Type II', 'ISO 27001', 'GDPR Compliant',
  'HIPAA Ready', '99.9% Uptime SLA', 'End-to-end Encrypted',
];

const GuestHero = () => {
  const { openRequestModal } = useGuest();

  return (
    <section className="bg-[ #ffffff] text-white py-24">
      <div className="max-w-screen-2xl mx-auto px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* Left Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#ff6600]/10 border border-[#ff6600]/30 text-[#ff6600] px-4 py-1.5 rounded-full text-sm font-semibold mb-8">
              <span className="w-2 h-2 rounded-full bg-[#ff6600]"></span>
              VERIFIED TRUST CENTER
            </div>
            <h1 className="text-5xl font-bold leading-tight mb-6 text-[#171a1f]">
              Your customers<br />deserve to trust you<br />
              <span className="italic text-[#ff6600]">— effortlessly.</span>
            </h1>
            <p className="text-[#919191] text-lg mb-10 leading-relaxed">
              My Risk Shield is a managed trust center platform. We handle
              the compliance communication layer between you and your
              customers — so trust is always visible, accessible, and
              verifiable.
            </p>
            <div className="flex flex-wrap gap-4 mb-12">
              <button
                onClick={openRequestModal}
                className="bg-[#ff6600] text-white px-8 py-3 hover:bg-[#0077b5]/80 font-semibold transition-colors"
              >
                Send a request
              </button>
              <button
                onClick={() => window.open('https://outlook.office365.com/owa/calendar/ITPeopleNetworkRiskAssessmentSupport@itpeoplenetwork.com/bookings/', '_blank')}
                className="border border-[#919191]/50 text-[#5e6060] px-8 py-3  hover:bg-white/5 transition-colors"
              >
                Schedule a demo
              </button>
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-[#919191]">
              {CERTIFICATIONS.map((cert) => (
                <span key={cert} className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-[#ff6600] flex-shrink-0"></span>
                  {cert}
                </span>
              ))}
            </div>
          </div>

          {/* Right - Trust Flow Model Card */}
          <div className="flex justify-center lg:justify-end">
            <div className="bg-[#ffffff] border border-[#919191]/20  p-6 w-full max-w-sm shadow-2xl">
              <p className="text-xs font-semibold tracking-widest text-[#919191] uppercase mb-5">Trust Flow Model</p>

              {/* End Customer */}
              <div className="bg-white/10 border border-[#919191]/20  p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#0b79b8] flex items-center justify-center flex-shrink-0">
                  <FiUser className="text-white text-lg" />
                </div>
                <div>
                  <p className="text-xs text-[#919191] mb-0.5">Your customer</p>
                  <p className="font-bold text-[#0b79b8]">End Customer</p>
                </div>
              </div>

              {/* Connector */}
              <div className="flex justify-center my-1.5">
                <div className="w-0 border-l-2 border-dashed border-[#919191]/30 h-6"></div>
              </div>

              {/* My Risk Shield - highlighted */}
              <div className="bg-[#0077b5]  p-5">
                <p className="text-xs font-semibold text-white/70 tracking-widest uppercase mb-1">Managed By</p>
                <p className="font-extrabold text-white text-xl mb-3">My Risk Shield</p>
                <span className="inline-flex items-center gap-1.5 bg-[#0000003b] border border-[#ffffff]/30 text-[#ffffff] text-xs px-3 py-1 rounded-full font-semibold">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#ff6600]"></span>
                  Trust Center Active
                </span>
              </div>

              {/* Connector */}
              <div className="flex justify-center my-1.5">
                <div className="w-0 border-l-2 border-dashed border-[#919191]/30 h-6"></div>
              </div>

              {/* Your Organization */}
              <div className="bg-white/10 border border-[#919191]/20  p-4 flex items-center gap-3">
                <div className="w-10 h-10  bg-[#ff6600]/20 border border-[#ff6600]/30 flex items-center justify-center flex-shrink-0">
                  <FiFileText className="text-[#ff6600] text-lg" />
                </div>
                <div>
                  <p className="text-xs text-[#919191] mb-0.5">Our client</p>
                  <p className="font-bold text-[#ff6600]">Your Organization</p>
                </div>
              </div>

              {/* Footer note */}
              <div className="mt-4 pt-4 border-t border-[#919191]/20 text-center">
                <p className="text-xs text-[#919191]">↑ All requests &amp; responses are routed through us</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default GuestHero;
